import { UserRole } from '../../../../store/auth/types';
import { getColumns } from './columns';
import { Column } from '../types';
import { ITab } from 'types';

export const getGridColumns = (
  role: UserRole,
  isVisaStatusVisible: boolean,
  isArrStatusVisible: boolean,
  isAccStatusVisible: boolean,
  isServicesVisible: boolean,
  isServiceProvider: boolean,
  isImmigrationProvidersVisible: boolean,
  isImmigrationProvider: boolean,
  isConditionalStatusVisible: boolean,
  isFollowUpDocsCountVisible: boolean,
  isDocsCountVisible: boolean,
  isAgentUser: boolean,
  isAgentDetailsStatusVisible: boolean,
  isAgentDocsCountVisible: boolean,
  hasAgentOnlyDocs: boolean,
  isFundsMatVisible: boolean,
  isDepositDateVisible: boolean,
  isRecordedInterviewVisible: boolean,
  isInterviewVisible: boolean,
  isOfferEnabled: boolean,
  screenWidth: number,
  isPathway: boolean,
  isNotInvited: boolean,
  isDaysInStageVisible: boolean,
  isShareCodeVisible: boolean,
  selectedRows?: string[],
): Column[] => {
  const visibleColumns = getColumns({ role, selectedRows, isPathway })
    .filter(col =>
      col.visible({
        role,
        isVisaStatusVisible,
        isArrStatusVisible,
        isAccStatusVisible,
        isConditionalStatusVisible,
        isPathway,
        isServicesVisible,
        isServiceProvider,
        isImmigrationProvidersVisible,
        isImmigrationProvider,
        isDepositDateVisible,
        isOfferEnabled,
        isFollowUpDocsCountVisible,
        isDocsCountVisible,
        isAgentUser,
        isAgentDetailsStatusVisible,
        isAgentDocsCountVisible,
        hasAgentOnlyDocs,
        isFundsMatVisible,
        isRecordedInterviewVisible,
        isInterviewVisible,
        isNotInvited,
        isDaysInStageVisible,
        isShareCodeVisible,
      }),
    )
    .map(col => col.item);

  const columnsWithoutAsignedWidth = visibleColumns.filter(col => {
    const width = Number(col.width);
    if (width) {
      screenWidth -= width;

      return false;
    }
    return true;
  }).length;
  const equalWidth = Math.round((screenWidth - 100) / columnsWithoutAsignedWidth);

  return visibleColumns.map(col => {
    if (col.width === undefined && col.responsive !== true) {
      col.width = equalWidth;
    }
    col.headerCellClass = `grid-HeaderCell rdg-column-${col.key}`;
    col.cellClass = () => `row grid-Cell`;
    return col;
  });
};

export const getColumnsForActiveTab = ({
  userRole,
  activeTab,
  tabs,
  partners,
  isServiceProvider,
  isEnrolyUser,
  isImmigrationProvider,
  isAgentUser,
  hasAgentOnlyDocs,
  isOfferEnabled,
  width,
  isPathway,
  selectedRows,
}: {
  userRole: UserRole;
  activeTab: string;
  tabs: ITab[];
  partners: string[];
  isServiceProvider: boolean;
  isEnrolyUser: boolean;
  isImmigrationProvider: boolean;
  isAgentUser: boolean;
  hasAgentOnlyDocs: boolean;
  isOfferEnabled: boolean;
  width: number;
  isPathway: boolean;
  selectedRows: string[];
}) => {
  // Custom logic to determine if Share Code column should be visible
  const isShareCodeVisible = ['Visa Issued', 'CAS Issued', 'Visa Refused'].includes(activeTab);
  const isAgentDetailsStatusVisible = ['Pre-Deposit', 'Post-Deposit'].includes(activeTab);

  const columns = getGridColumns(
    userRole,
    tabs.find(x => x.id === activeTab && x.isVisaStatusVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isArrStatusVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isAccStatusVisible) !== undefined,
    !!partners?.length,
    isServiceProvider,
    isEnrolyUser,
    isImmigrationProvider,
    tabs.find(x => x.id === activeTab && x.isConditionalStatusVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isFollowUpDocsCountVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isDocsCountVisible) !== undefined,
    !!isAgentUser,
    isAgentDetailsStatusVisible,
    tabs.find(x => x.id === activeTab && x.isAgentDocsCountVisible) !== undefined,
    !!hasAgentOnlyDocs,
    tabs.find(x => x.id === activeTab && x.isFundsMatVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isDepositDateVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isRecordedInterviewVisible) !== undefined,
    tabs.find(x => x.id === activeTab && x.isInterviewVisible) !== undefined,
    isOfferEnabled,
    width,
    isPathway,
    tabs.find(x => x.id === activeTab && x.isNotInvited) !== undefined,
    tabs.find(x => x.id === activeTab && x.isDaysInStageVisible) !== undefined,
    tabs.find(x => x.id === activeTab && isShareCodeVisible) !== undefined,
    selectedRows,
  );

  return columns;
};
